import { createFileRoute } from '@tanstack/react-router';

import { exigirAcceso } from '@/entities/usuario';
import { ProyectosListPage } from '@/pages/proyectos-list';

export const Route = createFileRoute('/_private/proyectos/')({
  beforeLoad: () => exigirAcceso('proyectos'),
  component: ProyectosListPage,
});
